import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { Urls } from '@/apiConnection/urls';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';
import { ApiService } from '@/apiConnection/ApiService';

@Component({
  imports: [
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
    CentToEurDisplayDirective,
  ],
  templateUrl: './ticket-list.page.html',
  encapsulation: ViewEncapsulation.None
})
export class TicketListPage {

  @ViewChild('sauTable')
  sauTable: { refresh: () => void; getItems: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  orientation: "dynamic" | "horizontal" | "vertical" = 'dynamic'
  showOptions = true

  public url = Urls.urls.tickets;

  public headers = [
    { name: 'Número', key: 'id_by_company' },
    { name: 'Fecha', key: 'date', type: 'dateTime' },
    { name: 'Cliente', key: 'client.name' },
    { name: 'Total', key: 'total' },
  ];

  public filterConfig: any = {
    orderParamName: 'sort',
    orderByFields: [
      { field: 'date', label: 'Fecha', defaultValue: true },
      { field: 'category_id', label: 'Familia' },
    ],
    order: ['dateRange', 'client', 'category', 'product', 'provider'],
    mobile: ['dateRange'],
    form: {
      dateRange: {
        name: 'Periodo',
        key: 'date_start',
        keyTo: 'date_end',
        type: 'dateRange',
        defaultValue: []
      },
      client: {
        name: 'Cliente',
        key: 'client_id',
        type: 'selectSimple',
        dropdowns: [],
      },
      category: {
        name: 'Familia',
        key: 'category_id',
        type: 'selectMultiple',
        dropdowns: [],
      },
      product: {
        name: 'Producto',
        key: 'products',
        type: 'selectSimple',
        dropdowns: [],
      },
      provider: {
        name: 'Proveedor',
        key: 'provider_id',
        type: 'selectSimple',
        dropdowns: [],
      },
    }
  };

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
  ) { }

  public dropdowns: any = {
    clients: [],
    products: [],
    categories: [],
    providers: [],
  };

  ngOnInit(): void {
    this.getDropdowns();
  }

  showEditAndDeleteButtons(): boolean {
    return true;
  }

  showPrintButton(): boolean {
    return true;
  }

  print(item: { id: number }) {
    window.open(`/ticket/print/${item.id}`, '_blank');
  }

  showDetails(item: { id: number }) {
    window.open(`/ticket/view/${item.id}`, '_blank');
  }

  toggleEditForm(item: { id: number }) {
    this.router.navigate(['/tickets/edit', item.id]);
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'ticket';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  getDropdowns() {
    const config = { clients: {}, products: {}, categories: {}, providers: {} };
    this.apiService.getSelectors(Urls.urls.selectors, config).subscribe({
      next: (data: any) => {
        this.dropdowns.categories = data.categories || [];
        this.dropdowns.clients = data.clients || [];
        this.dropdowns.products = data.products || [];
        this.dropdowns.providers = data.providers || [];

        this.filterConfig.form.category.dropdowns.push(...data.categories || [])
        this.filterConfig.form.client.dropdowns.push(...data.clients || [])
        this.filterConfig.form.product.dropdowns.push(...data.products || [])
        this.filterConfig.form.provider.dropdowns.push(...data.providers || [])

        this.cdr.detectChanges();
      }
    });
  }

}
